<script>
  import Vue from 'vue';

  export default Vue.directive('tooltip', {
    bind: function (el) {
      $(el).tooltip({
        boundary: 'window',
        trigger: 'hover'
      });
    },
    unbind: function (el) {
      $(el).tooltip('dispose');
    }
  })
</script>
